import script from "./BookingBrief.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingBrief.vue?vue&type=script&setup=true&lang=js"

import "./BookingBrief.vue?vue&type=style&index=0&id=52a919b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a919b0"]])

export default __exports__